module.exports = __webpack_public_path__ + "images/zoom_landing_mobile-1.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/zoom_landing_mobile-1.png
// module id = 863
// module chunks = 3